
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-drive",
      function () {
        return require("private-next-pages/destinations/google-drive.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-drive"])
      });
    }
  